angular.module('directives.dashboard').directive('wgtSaleTwoWeek', ['DashboardApiService',
        function (DashboardApiService) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtSaleTwoWeek/wgtSaleTwoWeek.tpl.html',
                link: function ($scope) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                $scope.data = response.data;
                                $scope.isLoaded = true;
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };
                    $scope.loadWidget();
                }
            };
        }]
);
